export class Pending2Fa implements Error {
  name: string = "Pending2Fa";
  message: string;
  code: string;
  stack?: string | undefined;

  constructor(
    message: string,
    code: string
  ) {
    this.message = message;
    this.code = code;
  }

}
